import React from 'react';
import PropTypes from 'prop-types';

import Booking from 'models/booking';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
};

const PastBookingModalPassNumber = ({ booking }) => {
  if (booking.onDemand) { return null; }

  return (
    <div className="booking-row parking-pass-number horizontal-padding">
      <span>PARKING PASS#</span>
      <strong>{booking.id}</strong>
    </div>
  );
};

PastBookingModalPassNumber.propTypes = propTypes;
export default PastBookingModalPassNumber;
